import react from "react";
import './SubsidiaryCompany.css'

import useMeta from '../../../hooks/useMeta'

import { SC_data } from "./SC_data";

import { Link, useParams } from "react-router-dom";

import Navbar from "../../../CommonComponent/Navbar/Navbar";
import NotificationBar from "../../../CommonComponent/Notification/NotificationBar";
import Footer from "../../../CommonComponent/Footer/footer";

const SC = () => {

    const { SC_PG_ID } = useParams();

    const CurrentPG = SC_data[SC_PG_ID];

    const pg_title = CurrentPG?.pg_title || null;

    const CurrentPG_Data = CurrentPG?.data || null;

    const Meta_title = CurrentPG?.Meta_title || null;
    const OG_title = CurrentPG?.OG_title || null;
    const Meta_Description = CurrentPG?.Meta_Description || null;
    const OG_Description = CurrentPG?.OG_Description || null;
    const Meta_OG_URl = CurrentPG?.Meta_OG_URl || null;


    useMeta({
        title: Meta_title,
        description: Meta_Description,
        canonical: Meta_OG_URl,
        og: {
            locale: 'en_US',
            type: 'article',
            title: OG_title,
            description: OG_Description,
            url: Meta_OG_URl,
            site_name: 'Marvel Blinds',
        },
    });


    return (
        <>
            <Navbar />
            <NotificationBar />
            <div className="SC_pg_container">
                <h2 className="SC_pg_title">{pg_title}</h2>
                {CurrentPG_Data.map((data, index) => (
                    <Link target="__blank" key={index} className="SC_content" to={data.url}>{data.title}</Link>
                ))}
            </div>
            <Footer />
        </>
    );
}

export default SC;